import {useMemo, useState} from 'preact/hooks';
import {Swiper, SwiperSlide} from 'swiper/react';
import cn from 'classnames';

import {Segmented} from './components';
import styles from '~/style/aigallery/successCases.module.less';
import {successCases as data, moduleTitleCn, moduleContentCn} from '~/locals/aigallery/index';
import {useQfScreen} from '../comp/utils/hook';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'successCases';
const swiperConfig = {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 'auto',
    autoplay: {
        delay: 0
    },
    speed: 5000
};

const logoNum = 18;
const SuccessCases = () => {
    const {screenWidth: width} = useQfScreen();
    const sliderLineNum = useMemo(() => {
        if (width < 600 || width > 1199) {
            return 0;
        }
        if (width < 1200 && width >= 768) {
            return 2;
        }
        return 3;
    }, [width]);
    const [sel, setSel] = useState(0);

    useCptDuration(id, {
        name: `${applicationName}-客户成功落地案例-停留时长`
    });

    return (
        <div className={styles.container} id={id}>
            <div className={cn(styles.title, `${moduleTitleCn}`)}>{data.title}</div>
            <div className={`${moduleTitleCn}`}>
                <Segmented
                    options={data.casesItem.map((item, i) => ({
                        value: i,
                        label: item.name,
                        icon: item.icon
                    }))}
                    value={sel}
                    onChange={setSel}
                />
            </div>
            <div className={cn(styles.cases, `${moduleContentCn}`)}>
                {data.casesItem[sel].card.map((item, i) => (
                    <div
                        className={styles['case-item']}
                        style={{
                            backgroundImage: `url(${item.bg})`
                        }}
                    >
                        <img
                            className={styles['case-item-icon']}
                            src={require('assets/qf/successCases/icon1.svg').default}
                            alt=""
                        />
                        <div className={styles['case-item-title']}>{item.name}</div>
                        <div className={styles['case-item-desc']}>{item.introduction}</div>
                        <div className={styles['case-item-hint']}>
                            {item.benefits.map(item => {
                                const title = item.split('|')?.[0] || '';
                                const desc = item.split('|')?.[1] || '';
                                return (
                                    <div className={styles['case-item-hint-item']}>
                                        <div className={styles['case-item-hint-item-title']}>{title}</div>
                                        <div className={styles['case-item-hint-item-desc']}>{desc}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
            <div className={cn(styles['subTitle-box'], `${moduleContentCn}`)}>
                <div className={styles.subTitle}>{data.subTitle}</div>
            </div>
            {width && width < 600 ? (
                (() => {
                    if (typeof window === 'undefined') {
                        return null;
                    }
                    const logoWidth = 83;
                    const logoMarginLR = 32;
                    const num = Math.floor((width - logoMarginLR) / logoWidth);
                    const line = Math.ceil(logoNum / num);
                    return new Array(line).fill('').map((item, i) => {
                        if (i === line - 1) {
                            const margin = (width - logoMarginLR - num * logoWidth) / (num - 1) / 2;
                            return (
                                <div className={cn(styles['logo-last'], `${moduleContentCn}`)}>
                                    {new Array(logoNum - num * (line - 1)).fill('').map((ele, index) => {
                                        return (
                                            <img
                                                className={styles['logo-item']}
                                                style={{
                                                    margin: `0 ${margin}px`
                                                }}
                                                src={
                                                    require(
                                                        `assets/qf/successCases/logo${index + num * (line - 1) > 9 ? index + num * (line - 1) : '0' + (index + num * (line - 1))}.png`
                                                    ).default
                                                }
                                                alt=""
                                            />
                                        );
                                    })}
                                </div>
                            );
                        }
                        return (
                            <div className={cn(styles.logo, `${moduleContentCn}`)}>
                                {new Array(num).fill('').map((ele, index) => {
                                    return (
                                        <img
                                            className={styles['logo-item']}
                                            src={
                                                require(
                                                    `assets/qf/successCases/logo${index + 1 + i * num > 9 ? index + 1 + i * num : '0' + (index + 1 + i * num)}.png`
                                                ).default
                                            }
                                            alt=""
                                        />
                                    );
                                })}
                            </div>
                        );
                    });
                })()
            ) : (
                <div className={cn(styles.logo, `${moduleContentCn}`)}>
                    {sliderLineNum === 0
                        ? new Array(logoNum).fill('').map((item, i) => {
                              return (
                                  <div className={styles['logo-item-box']}>
                                      <img
                                          className={styles['logo-item']}
                                          src={
                                              require(
                                                  `assets/qf/successCases/logo${i + 1 > 9 ? i + 1 : '0' + (i + 1)}.png`
                                              ).default
                                          }
                                          alt=""
                                      />
                                  </div>
                              );
                          })
                        : new Array(sliderLineNum).fill('').map((ele, index) => {
                              return (
                                  <Swiper {...swiperConfig} dir={index % 2 === 0 ? null : 'rtl'}>
                                      {new Array(logoNum / sliderLineNum).fill('').map((item, i) => {
                                          return (
                                              <SwiperSlide>
                                                  <div className={styles['logo-item-box']}>
                                                      <img
                                                          className={styles['logo-item']}
                                                          src={
                                                              require(
                                                                  `assets/qf/successCases/logo${i + (index * logoNum) / sliderLineNum + 1 > 9 ? i + (index * logoNum) / sliderLineNum + 1 : '0' + (i + (index * logoNum) / sliderLineNum + 1)}.png`
                                                              ).default
                                                          }
                                                          alt=""
                                                      />
                                                  </div>
                                              </SwiperSlide>
                                          );
                                      })}
                                  </Swiper>
                              );
                          })}
                </div>
            )}
        </div>
    );
};

export default SuccessCases;
